import { Component, Input } from '@angular/core';
import { Size } from '../../models/Size';

@Component({
  selector: 'mpf-map-size',
  templateUrl: './map-size.component.html',
  styleUrls: ['./map-size.component.scss']
})
export class MapSizeComponent {
  @Input() size: Size;
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/map-size/map-size.component.ts